import { render, staticRenderFns } from "./OrganizationConfigSecrets.vue?vue&type=template&id=59c91390&"
import script from "./OrganizationConfigSecrets.vue?vue&type=script&lang=js&"
export * from "./OrganizationConfigSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports